import React from 'react';
import { useHashtags } from '@/Recoil/Social';
import './styles/FilterTabs.scss';
import { navigateTo } from '@/Utils/routing';

interface FilterTabsProps {
    filter?: string;
    hashtag?: string;
    onFilterChange?: (filter: string | null, hashtag: string | null) => void;
}

const FilterTabs: React.FC<FilterTabsProps> = ({ filter, hashtag, onFilterChange }) => {
    const { trending } = useHashtags();
    
    const filterTabs = [
        { name: 'All Posts', value: null },
    ];
    
    const handleFilterChange = (filterValue: string | null) => {
        if (onFilterChange) {
            onFilterChange(filterValue, null);
        } else {
            if (filterValue) {
                navigateTo(`/social?filter=${filterValue}`);
            } else {
                navigateTo('/social');
            }
        }
    };
    
    const handleHashtagChange = (hashtagValue: string) => {
        if (onFilterChange) {
            onFilterChange(null, hashtagValue);
        } else {
            navigateTo(`/social?hashtag=${hashtagValue}`);
        }
    };
    
    return (
        <div className="FilterTabs">
            <div className="Wrapper">
                <div className="Container">
                    {/* Filter tabs */}
                    {filterTabs.map((tab) => (
                        <button
                            key={tab.value || 'all'}
                            onClick={() => handleFilterChange(tab.value)}
                            className={`Tab ${((!filter && !hashtag && !tab.value) || filter === tab.value) ? 'Active' : ''}`}
                        >
                            {tab.name}
                        </button>
                    ))}
                    
                    {/* Divider */}
                    <div className="Divider" />
                    
                    {/* Trending hashtags */}
                    {trending.map((tag_name) => (
                        <button
                            key={tag_name}
                            onClick={() => handleHashtagChange(tag_name)}
                            className={`Tab ${hashtag === tag_name ? 'Active' : ''}`}
                        >
                            #{tag_name}
                        </button>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default FilterTabs;